import { Group } from "./_components/group";
import { GroupLabel } from "./_components/groupLabel";
import { CheckboxItem } from "./_components/items/checkboxItem";
import { Item } from "./_components/items/item";
import { RadioItem } from "./_components/items/radioItem";
import { Separator } from "./_components/items/separator";
import { SubmenuItem } from "./_components/items/submenuItem";
import { Popup } from "./_components/popup";
import { RadioGroup } from "./_components/radioGroup";
import { Root } from "./_components/root";
import { Trigger } from "./_components/trigger";

export const Menu = {
    Root,
    Trigger,
    Popup,
    Item,
    SubmenuItem,
    CheckboxItem,
    Separator,
    RadioItem,
    GroupLabel,
    RadioGroup,
    Group,
};

export type { MenuGroupProps } from "./_components/group";
export type { MenuGroupLabelProps } from "./_components/groupLabel";
export type { MenuCheckboxItemProps } from "./_components/items/checkboxItem";
export type { MenuItemProps } from "./_components/items/item";
export type { MenuRadioItemProps } from "./_components/items/radioItem";
export type { MenuSeparatorProps } from "./_components/items/separator";
export type { SubmenuItemProps } from "./_components/items/submenuItem";
export type { MenuPopupProps } from "./_components/popup";
export type { MenuRadioGroupProps } from "./_components/radioGroup";
export type { MenuRootProps } from "./_components/root";
export type { MenuTriggerProps } from "./_components/trigger";
